<mat-card>
  <mat-card-content>

    <div id="top">
    <h1><b>Tax Identification Number Details</b></h1>
    <button  mat-fab extended  (click)="addTINButtonPressed()" class="warn" id="addTIN">ADD TAX IDENTIFICATION NUMBER</button>
    </div>

    <div class="content">
      <ag-grid-angular
        style="width: 100%; height: 500px"
        [rowData]="dataSource$ | async"
        [columnDefs]="colDefs"
        [suppressCellFocus]="true"
        [defaultColDef]="defaultColDef"
        (gridReady)="onGridReady($event)"
        [theme]="theme"
        [gridOptions]="gridOptions"
        (cellClicked)="onCellClicked($event)"
      />
    </div>
  </mat-card-content>
</mat-card>
